import React, { useCallback } from 'react';
import styled from 'styled-components';

import { PageTile, useMatchMedia } from '@make-software/cspr-ui';
import { Button, PageTileHeader } from '@block-explorer/ui';

import { HomeLayout } from '../../layouts';
import {
  BUY_CSPR_PATH,
  DEPLOY_LIST_PATH,
  HOME_PATH,
  TRANSACTION_LIST_PATH,
  VALIDATOR_LIST_PATH,
} from '../../router/paths';
import { useCustomHistory } from '../../router/utils';

import HomeDeploysList from './HomeDeploysList';
import HomeMetrics from './HomeMetrics';
import HomeValidatorList from './HomeValidatorList';
import { Trans, useTranslation } from 'react-i18next';
import { useWalletService } from '../../services';
import { HomeAdsBanner } from '../../components/ads-banner/ads-banners-by-page';

const Container = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    flexDirection: ['column'],
    width: '100%',
    height: '100%',
    marginTop: [24, -128, -128, -132],
  })
);

const CardsColumn = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    flexDirection: ['column', 'column', 'column', 'row'],
    marginTop: [16, 16, 16, 24],
    width: '100%',
    '& > *': {
      width: '100%',
    },
    '& > * + *': {
      marginTop: [16, 16, 16, 0],
      marginLeft: [0, 0, 0, 24],
    },
  })
);

export const PageTileFooter = styled('div')(({ theme }) =>
  theme.withMedia({
    padding: [20],
  })
);

export interface BlocksSceneProps {}

export const DashboardScene = (props: BlocksSceneProps) => {
  const history = useCustomHistory();
  const { t } = useTranslation();

  const screenType = useMatchMedia(['mobile', 'tablet', 'desktop'], []);
  const { buyCSPR, connect, isSignedIn } = useWalletService();

  const isTabletOrMobile = screenType !== 'desktop';

  if (history.location.pathname === BUY_CSPR_PATH) {
    if (config.with_buy_cspr_page) {
      if (!isSignedIn) {
        connect();
      } else {
        buyCSPR();
      }
    } else {
      history.replace(HOME_PATH);
    }
  }

  const getHandleViewAllClick = useCallback(
    (path) => () => {
      history.push(path);
    },
    [history]
  );

  return (
    <HomeLayout title={`CSPR.live | Casper Explorer by MAKE`}>
      <Container>
        <HomeMetrics />
        {isTabletOrMobile ? <HomeAdsBanner screenType={screenType} /> : null}
        <CardsColumn>
          <PageTile>
            <PageTileHeader tag={'h2'}>
              <Trans t={t}>Top Validators</Trans>
            </PageTileHeader>
            <HomeValidatorList />
            <PageTileFooter>
              <Button
                color={'secondaryRed'}
                onClick={getHandleViewAllClick(VALIDATOR_LIST_PATH)}
              >
                <Trans t={t}>View all Validators</Trans>
              </Button>
            </PageTileFooter>
          </PageTile>
          <PageTile>
            <PageTileHeader tag={'h2'}>
              {t('Latest Transactions')}
            </PageTileHeader>
            <HomeDeploysList />
            <PageTileFooter>
              <Button
                color={'secondaryRed'}
                onClick={getHandleViewAllClick(TRANSACTION_LIST_PATH)}
              >
                {t('View all Transactions')}
              </Button>
            </PageTileFooter>
          </PageTile>
        </CardsColumn>
      </Container>
    </HomeLayout>
  );
};

export default DashboardScene;
